import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { BusinessSegmentListComponent } from './business-segment-list/business-segment-list.component';

const routes:Routes=[
  {
    path: '',
    data: {
        title: 'Business Segment',
      },
    component: BusinessSegmentListComponent,
}
]

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes)
  ],
  exports:[RouterModule]
})
export class BussinessSegmentRoutingModule { }
